
import waves from '@/directive/waves'; // 水波纹指令

export default {
  directives: {
    waves: waves
  },
  props: {
    fnDelete: {
      type: Function,
      default: false
    },
    oObj: {
      type: Object,
      default: false
    },
    btnText: {
      type: String,
      default: '删除'
    },
    bHasIcon: {
      type: Boolean,
      default: true
    },
    sType: {
      type: String,
      default: 'danger'
    },
    bIsText: {
      type: Boolean,
      default: false
    },
    bIsLast: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible2: false
    };
  },

  methods: {
    handleDelete: function handleDelete() {
      if (this.fnDelete) {
        this.fnDelete(this.oObj);
        this.visible2 = false;
      }
    }
  }
};